/**
 * Created by Tiger on 21/03/2022.
 */

export const en = {

    privatisation: 'Private Configuration',
    configs_manager: 'MQTT Configuration',
    private_devices_manager: 'Push Configuration',

    second: 'second',
    seconds: 'seconds',
    minute: 'minute',
    minutes: 'minutes',
    hour: 'hour',
    hours: 'hours',
    config_name: 'Name',
    net_type: 'Private Type',
    ali_iot: 'Aliyun IoT',
    custom_mqtt: 'Self-built MQTT',
    encrypt_type: 'Encryption Method',
    secret_key: 'Secret Key',
    no_encrypt: 'Not Encrypted',
    fixed_encrypt: 'Fixed Key',
    report_interval: 'Interval of Uploading',
    collect_interval: 'Interval of Recording',
    ble_interval: 'Interval of BLE Broadcast',
    ble_name: 'Name of BLE Broadcast',
    device_count: 'Device Number',
    operations: 'Management',
    please_select: 'Please Select',
    re_select: 'Reselect',
    edit_ali_iot_info_tip: 'Aliyun IoT Server Information',
    custom_config: 'Custom Config',
    edit_mqtt_info_tip: 'Self-built MQTT Information',
    mqtt_protocol: 'MQTT Type',
    mqtt_protocol_mqtt: 'MQTT',
    mqtt_protocol_mqtts_ca: 'MQTTS (CA-signed certificate only)',
    add_config: 'Add Configuration',
    add: 'Add',
    host_area: 'Dregion',

    config: 'Name',
    config_message: 'Enter a configuration name',
    device_type: 'Device Model',
    config_status: 'Configure Send Status',
    config_sent_time: 'Send Time',
    active_time: 'Activation Time',
    create_time: 'Added Time',
    current_platform: 'Platform',

    add_device: 'Add Device',

    //menu
    menu_edit: 'Edit',
    menu_delete: 'Delete',
    change_config: 'Change Configuration',

    //edit config
    config_has_devices: '\'%1\' 配置下有 %2 台设备，需要先解绑设备后，才可删除配置。',
    confirm_to_delete_config: 'Are you sure you want to delete the configuration "%$"? ',

    //add device
    select_device_type: 'Select Device Model',
    select_devices: 'Select Device',
    select_devices2: 'Before configuration, please add the device to your account in the "Qingping IoT" app first.',
    select_config: 'Select Configuration',
    selected_devices_count: 'Total @$ devices',
    prev: 'Preview',
    next: 'Next',

    table_footer: '@$ devices selected',
    confirm_to_delete_device_title: 'Are you sure you want to delete the device "%$"?',
    confirm_to_delete_device_content: 'After deletion, only the association between device and configuration is deleted, but the device\'s local configuration will not be changed. Please restore the device to factory settings to clear the local configuration.',

    delete_success: 'Successfully deleted.',
    delete_failed: 'Failed to delete.',

    edit_success_title: 'Successfully edited',
    edit_success_fail: 'Failed to edit.',
    device__edit_success: '%0 devices\'s configuration has been changed to "%1". Please restore the device to factory settings, and the new configuration will be sent when the device is connected to Qingping\'s server. For Wi-Fi devices, please config the network in Qingping app after  reset to factory settings.',

    add_success_title: 'Successfully added.',
    add_success_fail: 'Failed to add.',
    add_success_sub_title: 'The private configuration will be sent when the device is connected to the Qingping\'s server. If the device is interval networking, you can press the button on the body  to actively trigger to connect. ',


    access_key_access_secret_tips: 'About AccessKey and AccessSecret, view ',
    access_key_access_secret_tips2: '3.2.3 RAM. ',

    product_key_tip: 'About ProductKey, view ',
    product_key_tip2: '3.2.2. ',

    mqtt_tips: 'Self-built MQTT, view ',
    mqtt_tips2: '3.2. ',

    use_thing_model: 'TSL',

    table_total: 'Total %$ items',
    qingping: '© Qingping',

    no_permission: 'No permission.',
    please_contact: 'Please contact:',
    contact_email: 'Email: ',
    contact_tel: 'Tel: %@',

    // new tabs
    unsent_devices: 'Not Pushed',
    sent_devices: 'Pushed',
    config_send_status: 'Send Status',
    send_config: 'Push Configuration',
    send_config_success: 'Send Success',
    send_config_failed: 'Send Failed',
    send_config_success_sub_title: 'Private configuration has been pushed to @$ devices and will take effect once they are connected to the internet.',
    sent: 'Pushed',
    unsent: 'Not Pushed',
    consent: 'Confirm',
    cancel: 'Cancel',
    send_private_mqtt_config: 'Send Private MQTT Config',
    select_private_config: 'Select Private Config',

    // Edit MQTT Config Success Tips
    mqtt_config_modified_title: 'Private MQTT configuration "%$" has been modified',
    attention_label: 'Attention:',
    mqtt_config_modified_warning: 'This configuration only updates cloud records. To make it effective on the device, please follow the steps below:',
    wifi_device_step_label: '1. Wi-Fi device:',
    wifi_device_step_text: 'Please restore it to factory settings, then use the Qingping IoT App (More > Advanced > Configure Wi-Fi) to reconfigure the network and pull the new configuration.',
    nb_iot_device_step_label: '2. NB-IoT / Cat-1 device:',
    nb_iot_device_step_text: 'Only restore to factory settings; the device will automatically pull the new configuration.',
    i_known: 'Got it',

    // Device Config Modified Success Tips
    device_config_modified_title: 'Configuration Updated',
    device_config_attention_label: 'Note:',
    device_config_warning: 'Changes are currently saved in the cloud only. To apply them to your device:',
    device_config_wifi_step_label: 'Wi‑Fi devices:',
    device_config_wifi_step_text: 'Reset to factory settings, then reconfigure Wi‑Fi in the Qingping IoT App (More > Advanced > Configure Wi‑Fi) to pull the new settings.',
    device_config_nb_iot_step_label: 'NB‑IoT / Cat‑1 devices:',
    device_config_nb_iot_step_text: 'Simply reset to factory settings. The device will automatically fetch the new configuration.',
};
